import { ReactElement, useContext } from "react"

import { SYS_ADMIN_LCT_STEPS } from "../../../../../constants/lct/evac/deviceForm"
import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { NON_SYS_ADMIN_EVDC_STEPS } from "../../formSpecs/evdcSpec"
import { CreateEVDCDeviceContext } from "../providers/baseProviders/createEVDCDeviceProvider"

/** AppStepper for EVDC device creation
 */
const CreateEvdcDeviceProgressStepper = (): ReactElement => {
    const { currentIndex, canEditManufacturer } = useContext(
        CreateEVDCDeviceContext
    )

    const steps = canEditManufacturer
        ? [...SYS_ADMIN_LCT_STEPS, ...NON_SYS_ADMIN_EVDC_STEPS]
        : NON_SYS_ADMIN_EVDC_STEPS

    return <AppStepper stepLabels={steps} currentStepIndex={currentIndex} />
}

export default CreateEvdcDeviceProgressStepper
